import { INSTAGRAM_URL, SOCIAL_HANDLE, TIKTOK_URL } from '../../lib/constants';
import { Instagram, ArrowUpRight } from 'lucide-react';

// Custom TikTok glyph (lucide-react doesn't ship one)
const TikTokIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.95a8.16 8.16 0 0 0 4.77 1.52V7.04a4.85 4.85 0 0 1-1.84-.35z" />
  </svg>
);

export const SocialFollow = () => {
  return (
    <section
      id="social"
      data-testid="social-section"
      className="bg-brand-bg border-t border-brand-gold/10"
    >
      <div className="container-prep py-16 sm:py-20">
        <div className="text-center mb-10">
          <p className="eyebrow mb-4">Follow Along</p>
          <h2 className="heading-2">
            See more on
            <span className="italic block text-brand-gold">{SOCIAL_HANDLE}</span>
          </h2>
          <p className="body-lg max-w-xl mx-auto mt-5">
            Daily lash transformations, before & afters, and behind-the-scenes
            from the Prép Beauty Parlour studio on Burrard St.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-3xl mx-auto">
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="social-instagram"
            className="group flex items-center gap-5 bg-brand-bgElev border border-brand-gold/15 rounded-2xl p-6 hover:border-brand-gold/50 hover:bg-brand-bgSoft hover:-translate-y-0.5 transition-all"
          >
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF] flex items-center justify-center text-white shrink-0">
              <Instagram size={22} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="eyebrow mb-1">Instagram</div>
              <div className="font-serif text-xl text-brand-cream leading-tight">{SOCIAL_HANDLE}</div>
            </div>
            <ArrowUpRight
              size={18}
              className="text-brand-muted group-hover:text-brand-gold group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
            />
          </a>

          <a
            href={TIKTOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="social-tiktok"
            className="group flex items-center gap-5 bg-brand-bgElev border border-brand-gold/15 rounded-2xl p-6 hover:border-brand-gold/50 hover:bg-brand-bgSoft hover:-translate-y-0.5 transition-all"
          >
            <div className="w-14 h-14 rounded-2xl bg-brand-ink border border-brand-gold/40 flex items-center justify-center text-brand-cream shrink-0">
              <TikTokIcon size={22} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="eyebrow mb-1">TikTok</div>
              <div className="font-serif text-xl text-brand-cream leading-tight">{SOCIAL_HANDLE}</div>
            </div>
            <ArrowUpRight
              size={18}
              className="text-brand-muted group-hover:text-brand-gold group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
            />
          </a>
        </div>
      </div>
    </section>
  );
};

export { TikTokIcon };
export default SocialFollow;
